module.exports = __webpack_public_path__ + "static/media/info1.c0eb9c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stores/steps/info1.png
// module id = 328
// module chunks = 0